define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/heading/Ref",
	"csi/core/Key",
	"csi/xml"
], function(declare, heading, Ref, Key, xml) {

	return declare(Ref, {
		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: render Node Name heading if item is unlinked
			var sample = ctx.getNode();

			if (sample && sample.HiddenProduct) {
				ctx.pushParams().setNodeURL(ctx.getNode()[h.m_id]);
				ctx.__popContext = true;
			} else {
				this.inherited(arguments);
			}
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context if pushed above
			if (ctx.__popContext) {
				ctx.__popContext = false;
				ctx.pop();
			}

			this.inherited(arguments);
		},

		headingToHtml: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			// summary: switch to Node Name renderer along path if available and do not render links to hidden products
			if (ctx.__popContext) {
				var hName = ctx.view.getHeading(new Key({id: xml.ATTR_NAME, path: xml.path(h.m_id)}));
				hName.m_link = null;
				heading.getRenderer(xml.ATTR_STRING).headingToHtml(ctx, hName, refNode);
			} else {
				this.inherited(arguments);
			}
		}
	});
});